export default "__VITE_ASSET__3538ca68__$_?nuxt_component=async__"